import { render, staticRenderFns } from "./strategies-faster-payoff.vue?vue&type=template&id=1a134d73"
import script from "./strategies-faster-payoff.vue?vue&type=script&lang=js"
export * from "./strategies-faster-payoff.vue?vue&type=script&lang=js"
import style0 from "./strategies-faster-payoff.vue?vue&type=style&index=0&id=1a134d73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports